





























































import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'RegisterAgreement'
})
export default class PrivacyAgreement extends Vue {
  created() {
    document.title = '用户注册协议';
  }
}
